import React from "react";
import { Button, Col, FormControl, InputGroup, Row } from "react-bootstrap";
import { ISearchBoxProps } from "../../interfaces/Components/SearchBox/ISearchBoxProps";
import { useRef } from "react";
import { IconButton } from "../IconButton/IconButton";
import { IconButtonType as IconType } from "../../interfaces/Components/IconButton/IIconButton";

export const SearchBox = ({uniqueName, placeholder, buttonLabel, onSearch, showClearButton} : ISearchBoxProps) => {

    const searchBoxRef = useRef<HTMLInputElement>(null);

    const handleOnSearch = () => {
        const value : string = (searchBoxRef.current) ? searchBoxRef.current.value : "";
        onSearch(value);
    }

    const handleClearSearch = () => {
        if(searchBoxRef.current) {
            searchBoxRef.current.value = "";
        }
        onSearch("");
    }

    const renderSearchButton = () => {
        return  <Button variant="primary" id={`${uniqueName}-search-button`} onClick={handleOnSearch}>
                    {buttonLabel}
                </Button>;
    };

    const renderClearButton = () => {
        return  <IconButton
                    id={`${uniqueName}-clear-button`}
                    iconType={IconType.Cancel}
                    variant="secondary"
                    onClick={() => handleClearSearch()}
                    className="no-margin"
                    aria-label="Clear Search">
                </IconButton>
    };

    return  <Row>
                <Col className="px-2">
                    <InputGroup>
                        <FormControl
                            id={`${uniqueName}-search-box`}
                            placeholder={placeholder}
                            aria-label={`${placeholder} search`}
                            ref={searchBoxRef}
                            onKeyUp = {(e) => { if (e.key === 'Enter') handleOnSearch() }}
                        />
                        {showClearButton && renderClearButton()}
                    </InputGroup>
                </Col>
                <Col xs="auto" className="p-0">
                    {renderSearchButton()}
                </Col>
            </Row>
};